import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET_MOST_PRACTICED_SCENARIOS, GET_PRACTICE_SCENARIOS, PIN_SCENARIO, UNPIN_SCENARIO } from '../../action-type';
import {
  GetMostPracticedScenarios,
  GetPracticeScenarios,
  HttpClient,
  HttpRequest,
  PinScenario,
  RequestMethod,
  UnpinScenario
} from '@/api';
import { DonorScenarioResponse } from '@/types/scenarios';
import { HttpApiResponse, HttpRejectResponse } from '@/api/interfaces';
import { MostPracticedScenarioRequest, MostPracticedScenarioResponse } from './interfaces';

export const getPracticeScenarios = createAsyncThunk<DonorScenarioResponse>(
  GET_PRACTICE_SCENARIOS,
  async (_, { rejectWithValue }) => {
    try {
      const response = await HttpRequest({
        url: GetPracticeScenarios,
        method: RequestMethod.GET
      });

      return response as DonorScenarioResponse;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to fetch practice scenarios';
      return rejectWithValue(errorMessage);
    }
  }
);

/*
export const getMostPracticedScenarios = createAsyncThunk<PracticeScenario[]>(
  GET_MOST_PRACTICED_SCENARIOS,
  async (_, { rejectWithValue }) => {
    try {
    console.log('Calling End point to fetch most practiced scenarios')
      const response = await HttpRequest({
        url: GetMostPracticedScenarios,
        method: RequestMethod.GET,
      });

      return response as PracticeScenario[];
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Failed to fetch most practiced scenarios";
      return rejectWithValue(errorMessage);
    }
  }
);
*/

export const MostPracticedScenarios = createAsyncThunk<
  HttpApiResponse<MostPracticedScenarioResponse>, // success return shape
  MostPracticedScenarioRequest, // input arg
  HttpRejectResponse
>(GET_MOST_PRACTICED_SCENARIOS, async (payload, thunkAPI) => {
  try {
    const response = await HttpClient<MostPracticedScenarioResponse>({
      method: 'POST',
      url: GetMostPracticedScenarios,
      data: payload
    });
    return response;
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      message: error.message,
      status: error.response?.status
    });
  }
});

export const pinScenario = createAsyncThunk(PIN_SCENARIO, async (scenarioId: string, { rejectWithValue }) => {
  try {
    const [prefixPath, suffixPath] = PinScenario.split(':scenario_id');
    const url = `${prefixPath}${scenarioId}${suffixPath}`;

    await HttpRequest({
      url,
      method: RequestMethod.POST
    });

    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to pin scenario';
    return rejectWithValue(errorMessage);
  }
});

export const unpinScenario = createAsyncThunk(UNPIN_SCENARIO, async (scenarioId: string, { rejectWithValue }) => {
  try {
    const [prefixPath, suffixPath] = UnpinScenario.split(':scenario_id');
    const url = `${prefixPath}${scenarioId}${suffixPath}`;

    await HttpRequest({
      url,
      method: RequestMethod.DELETE
    });

    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to unpin scenario';
    return rejectWithValue(errorMessage);
  }
});
